import { useState, useEffect } from 'react';
import RetroGrid from './RetroGrid';
import FloatingShapes from './FloatingShapes';

const VaporwaveAesthetics = () => {
  // Check dark mode directly from DOM to avoid context re-render loops
  const [isDarkMode, setIsDarkMode] = useState(() =>
    document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    // Only check on mount - don't watch for changes to avoid re-renders
    setIsDarkMode(document.documentElement.classList.contains('dark'));
  }, []); // Empty deps - only run once

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: -1,
      }}
      aria-hidden="true"
    >
      {/* Layer 1: Retro perspective grid */}
      <div style={{ opacity: isDarkMode ? 0.4 : 0.25 }}>
        <RetroGrid />
      </div>

      {/* Layer 2: Floating geometric shapes */}
      <FloatingShapes isDarkMode={isDarkMode} />
    </div>
  );
};

export default VaporwaveAesthetics;
